import { Box, Card, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Iframe from "react-iframe";

function Calendar() {
  const { t } = useTranslation();

  return (
    <>
      <Box flexDirection={"column"} gap={2} display={"flex"}>
        <Box width={"100%"}>
          <Card
            sx={(theme) => ({
              p: {
                xs: "20px",
                sm: "25px 30px",
              },
              background: theme.palette.background.cardGradient,
              borderRadius: "20px",
              height: "100%",
            })}
          >
            <Stack gap={"20px"}>
              <Grid container spacing={2}>
                <Typography
                  color="secondary.light"
                  variant="h4"
                  fontWeight={600}
                >
                  {t("Calendars.Calendar")}
                </Typography>
                <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                  <Iframe
                    src={`${process.env.REACT_APP_EVENT_CALENDAR}`}
                    style={{ border: "0px" }}
                    width="100%"
                    height="600"
                    frameborder="0"
                    scrolling="no"
                  ></Iframe>
                </Grid>
              </Grid>
            </Stack>
          </Card>
        </Box>
      </Box>
    </>
  );
}

export default Calendar;
